import React, {useState} from "react";
import {Translation} from "react-i18next";

const BoxLayoutForTicketInfo = ({count, text}) => {
    return (
        <div className="ebs-counters-box">
            <div className="ebs-box-wrapp">
                <h4 className="text-center">
                    {count || 0}
                </h4>
                <p className="text-center">
                    {text}
                </p>
            </div>
        </div>
    )
}
const WaitingListCounters = ({remainingTickets, pendingTickets, sentOffers, confirmedAttendees, notInterested, setOrders, state}) => {

    const [selectedCounterBox, setSelectedCounterBox] = useState({
        pendingCounter: false,
        sentCounter: false
    })
    //show filtered data based on the selected div
    const showFilteredInvites = (filter) => {
        //if already selected set both to false
        if (selectedCounterBox[filter] === true) {
            setSelectedCounterBox({
                pendingCounter: false,
                sentCounter: false
            })

            //reset orders to original state
            setOrders(state.waitingListOrders.data);
        } else {
            //select clicked box and set state
            setSelectedCounterBox({
                pendingCounter: filter === 'pendingCounter',
                sentCounter: filter === 'sentCounter'
            })
            if (state && state.waitingListOrders) {
                //filter data based on the selected div
                const filteredOrders = state.waitingListOrders.data.filter(
                    // replace('Counter', '') will replace Counter in pendingCounter
                    // and sentCounter and the remaining text will be sent or pending
                    order => order.order_attendee_status.toLowerCase() === filter.replace('Counter', '')
                );
                setOrders(filteredOrders)
            }
        }
    }
    return(
        <Translation>
            {(t) => (
                <div className="ebs-wishlist-box">
                    <div className="row d-flex">
                        <div className="col">
                            <BoxLayoutForTicketInfo count={remainingTickets} text={t('WAITING_LIST_COUNTER_REMAINING_TICKETS')} />
                        </div>
                        <div className={`col ${selectedCounterBox.pendingCounter && "selected-box bg-primary"}`}
                             onClick={() => showFilteredInvites('pendingCounter')}>
                            <BoxLayoutForTicketInfo count={pendingTickets} text={t('WAITING_LIST_COUNTER_PENDING')} />
                        </div>

                        <div className={`col ${selectedCounterBox.sentCounter && "selected-box bg-primary"}`}
                             onClick={() => showFilteredInvites('sentCounter')}>
                            <BoxLayoutForTicketInfo count={sentOffers} text={t('WAITING_LIST_COUNTER_SENT')} />
                        </div>
                        <div className="col">
                            <BoxLayoutForTicketInfo count={confirmedAttendees} text={t('WAITING_LIST_COUNTER_ATTENDING')} />
                        </div>
                        <div className="col">
                            <BoxLayoutForTicketInfo count={notInterested} text={t('WAITING_LIST_COUNTER_NOT_INTERESTED')} />
                        </div>
                    </div>
                </div>
            )}
        </Translation>
    )
}

export default WaitingListCounters